"use client";

import { useClientTranslations } from "@/lib/translate";
import {
  Briefcase01Icon,
  ArtificialIntelligence01Icon,
  DashboardSquare01Icon,
  AiChat01Icon,
  Calendar01Icon,
  UserGroupIcon,
} from "hugeicons-react";

export const BusinessFeatures = () => {
  const { t } = useClientTranslations("business-landing");

  const features = [
    {
      id: "postJob",
      icon: <Briefcase01Icon className="h-8 w-8 text-primary" />,
    },
    {
      id: "aiMatching",
      icon: <ArtificialIntelligence01Icon className="h-8 w-8 text-primary" />,
    },
    {
      id: "management",
      icon: <DashboardSquare01Icon className="h-8 w-8 text-primary" />,
    },
    {
      id: "chat",
      icon: <AiChat01Icon className="h-8 w-8 text-primary" />,
    },
    {
      id: "calendar",
      icon: <Calendar01Icon className="h-8 w-8 text-primary" />,
    },
    {
      id: "collaboration",
      icon: <UserGroupIcon className="h-8 w-8 text-primary" />,
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold sm:text-4xl text-gray-900 mb-4">
            {t("features.title")}
          </h2>
          <div className="h-1.5 w-24 bg-primary mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:-translate-y-1"
            >
              <div className="bg-primary/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {t(`features.${feature.id}.title`)}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t(`features.${feature.id}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

BusinessFeatures.displayName = "BusinessFeatures";
